import '../css/loaderTabla.css';
export const LoaderTabla = ({white}) => {
    return (
        <div className='mt-5 text-center'>
            <span class={`loaderTabla mx-auto ${white?'loaderWhite':''}`}></span>
            <span class={`loaderTexto mt-4 ${white?'loaderWhite':''}`}>Cargando</span>
        </div>
    )
}